import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import Modal from "../Modal";
import store from "../../../storeWire";
import { SET_QUOTE_POPUP_STATUS } from "../../../store/slice/component/QuotePopup";
import { system_notification } from "../../../store/slice/system";
import OpenQuoteRepository from 'src/repository/OpenQuoteRepository';
import PlusMinusInputWithDebounceRFQ from 'src/component/PlusMinusInputWithDebounceRFQ';
import CurrencyOptions from '../Quote/CurrencyOptions';
import Common from 'src/pages/Quote/Common';
import { Tooltip } from 'src/component/Tooltip';
import { useQuoteStore } from 'src/hooks/quote';
import CartRepository from 'src/repository/CartRepository';
import ProductRepository from "../../../repository/ProductRepository";
import produceClone from "../../../helper/produceClone";
import Constants from 'src/support/Constants';
import Helper from 'src/support/Helper';
import QuoteCustomerPartNumberOptions from '../QuoteCustomerPartNumberOptions';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import ReusableDiv from 'src/support/ReusableDiv';
import useReduxState from 'src/hooks/useReduxState';
import { __remove, __set } from 'src/store/axios_indicator';

const QuotePopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const QUOTE_POPUP_STATUS = useSelector((state) => state.entities.component_QuotePopup.QUOTE_POPUP_STATUS);
    const [{ QuotePopup }, { }, { }] = useDOMAttachToSystemStore();
    const currentProduct = QuotePopup && QuotePopup.data && QuotePopup.data.single_product;
    const isEdit = (QuotePopup.data?.current_quote && Object.entries(QuotePopup.data?.current_quote)?.length > 0) ? true : false;
    const targetUnitPricePattern = /^(\d+)(\d{1,2}|\.\d{1,5})?$/;
    const defaultQtyVal = false;
    const modal = {
        customerPartNumber: '',
        targetCurrency: window.mct,
        quantity1: currentProduct.QtyMin,
        quantity2: defaultQtyVal,
        quantity3: defaultQtyVal,
        targetUnitPrice: '',
        endCustomer: "",
        competition: "",
        comments: ""
    }
    const [rfqQty, setRfqQty] = useState(currentProduct.QtyMin);
    const [quoteDetail, setQuoteDetail] = useState(modal);
    const [detailValidation, setDetailValidation] = useState({});
    const [{ }, { get_RFQ_quantity }, { edit_quote_save, set_is_success_action }] = useQuoteStore();
    const [manualRfqQty, setManualRfqQty] = useState(-1);
    const [isDisabled, setIsDisabled] = useReduxState(false, 'setIsDisabled');
    const selected_cpn = QuotePopup.data.selected_cpn; // 14979
    const addFrom = QuotePopup?.data?.addFrom


    useEffect(() => {
        store.dispatch(SET_QUOTE_POPUP_STATUS({ QUOTE_POPUP_STATUS: true }));
        if (isEdit) {
            const detail = QuotePopup.data?.current_quote;
            const detailModal = {
                quoteLineItemId: detail.quoteLineItemId,
                customerPartNumber: (detail.customerPartNumber !== null && detail.customerPartNumber !== "*") ? detail.customerPartNumber : "",
                targetCurrency: detail.targetCurrency,
                quantity1: detail.quantity1,
                quantity2: detail?.quantity2 === 0 ? false : detail?.quantity2,
                quantity3: detail?.quantity3 === 0 ? false : detail?.quantity3,
                targetUnitPrice: detail.targetUnitPrice,
                endCustomer: detail.endCustomer,
                competition: detail.competition,
                comments: detail.comments
            }
            setQuoteDetail(detailModal);
            (async () => {
                const minQty = await getRfqVal(detail.customerPartNumber);
            })();
        }
        else {
            __set('COMMON_API_CALL');
            let cpn = "";
            if (currentProduct.ItemNumber) {
                cpn = selected_cpn ? selected_cpn : new CartRepository().getCustomerPartNumberFromERPPArtNumber(currentProduct.ItemNumber);
            } else {
                cpn = ''
            }
            if (!cpn && currentProduct?.CustomerPartNumbers?.length > 0 && currentProduct.CustomerPartNumbers[0].CPN !== undefined) {
                cpn = currentProduct?.CustomerPartNumbers[0]?.CPN;
            }

            (async () => {
                const minQty = await getRfqVal(cpn);
                setQuoteDetail({
                    ...quoteDetail,
                    quantity1: minQty !== 0 ? minQty : currentProduct.QtyMin,
                    customerPartNumber: cpn !== "*" ? cpn : ""
                });
            })();
        }
    }, []);

    async function getManualRFQVal() {
        __set('COMMON_API_CALL');
        if (manualRfqQty === -1) {
            const minQty = await get_RFQ_quantity(currentProduct, "*");
            setManualRfqQty(minQty)
            return minQty;
        }
        __remove('COMMON_API_CALL');
        return manualRfqQty;
    }

    async function getRfqVal(cpnNo) {
        __set('COMMON_API_CALL');
        let rfqMinQty = 0;
        const _isManual = Common.isCpnIsManual(props.data.single_product, cpnNo);
        if (_isManual) {
            rfqMinQty = await getManualRFQVal();
        } else {
            rfqMinQty = await get_RFQ_quantity(currentProduct, cpnNo);
        }
        setRfqQty(rfqMinQty);
        __remove('COMMON_API_CALL');
        return rfqMinQty;
    }

    const onValueChange = (field, value) => {
        setQuoteDetail({ ...quoteDetail, [field]: value });
    }

    const onHide = (action = true) => {
        store.dispatch(SET_QUOTE_POPUP_STATUS({ QUOTE_POPUP_STATUS: false }))
    };

    const handleChange = (i, e) => {
        let qty = `quantity${i}`;
        onValueChange(qty, e.target.value);

        if (e.target.err) {
            setDetailValidation({ ...detailValidation, [qty]: e.target.err });
        } else {
            let validation = produceClone(detailValidation);
            delete validation[qty];
            setDetailValidation(validation);
        }
    }
    const removeFormFields = (i) => {
        let detailModel = produceClone(quoteDetail);
        let validation = produceClone(detailValidation);

        if (i === 2) {
            delete validation?.quantity2
            if (detailModel.quantity3 !== defaultQtyVal) {
                detailModel.quantity2 = detailModel.quantity3;
                detailModel.quantity3 = defaultQtyVal;
                if (validation?.quantity3) {
                    validation.quantity2 = validation.quantity3;
                    delete validation.quantity3
                }
            } else {
                detailModel.quantity2 = defaultQtyVal;
            }
        } else {
            detailModel.quantity3 = defaultQtyVal;
            delete validation?.quantity3
        }
        setQuoteDetail(detailModel)
        setDetailValidation(validation)
    }

    const onSubmit = async () => {
        let params = { ...quoteDetail };
        const isValid = await validateData(params);
        if (!isValid) {
            return false;
        } else {
            if (currentProduct?.CustomerPartNumbers?.length > 0 && params.customerPartNumber === "") {
                params.customerPartNumber = "*";
            }
            if (isEdit) {
                const quotes = [{ params }]
                await edit_quote_save(quotes);
                set_is_success_action(true)
                onHide();
            } else {
                if (currentProduct !== undefined) {
                    if (currentProduct.ERPPartNumber !== undefined) {
                        let d = ProductRepository.detectStringIsItemNumber(currentProduct.ERPPartNumber);
                        if (d === false) {
                            params.partNumber = currentProduct.ERPPartNumber;
                        }
                    }

                    params.itemNumber = Helper.valueIsNotNull(currentProduct.ItemNumber) ? currentProduct.ItemNumber : "";
                    params.erpManufacturerPartNumber = Helper.valueIsNotNull(currentProduct.ERPMFRPartNumber) ? currentProduct.ERPMFRPartNumber : "";
                    params.erpManufacturerCode = Helper.valueIsNotNull(currentProduct.ERPManufacturerCode) ? currentProduct.ERPManufacturerCode : "";
                    params.manufacturerName = Helper.valueIsNotNull(currentProduct.ManufacturerName) ? currentProduct.ManufacturerName : "";
                }

                await new OpenQuoteRepository().addOpenQuote(params).then(res => {
                    onHide();
                    let propsData = {...props.data};
                    propsData.quantity = res?.data?.quantity1;
                    store.dispatch(system_notification({
                        name: 'AddedPartQuotePopup',
                        data: propsData,
                    }));
                    resetForm();
                })

                /* Set Events and Evars as per basav comment (14664) - Devanshi Patel */
                Helper.setEvars(currentProduct.ERPMFRPartNumber, "Add to Quote clicked from " + addFrom)
                
            }
        }
    };

    const validateData = async (params) => {
        if (Object.entries(detailValidation).length > 0) {
            return false;
        } else {
            params.quantity2 = params.quantity2 === false ? 0 : params.quantity2;
            params.quantity3 = params.quantity3 === false ? 0 : params.quantity3;
            const isValid3 = await Common.validateDuplicateQty('quantity3', params.quantity1, params.quantity2, params.quantity3);
            if (!isValid3) {
                setDetailValidation({ quantity3: Constants.validateQtyMsg })
                return false;
            }

            const isValid2 = await Common.validateDuplicateQty('quantity2', params.quantity1, params.quantity2, params.quantity3);
            if (!isValid2) {
                setDetailValidation({ quantity2: Constants.validateQtyMsg })
                return false;
            }

            const isValid1 = await Common.validateDuplicateQty('quantity1', params.quantity1, params.quantity2, params.quantity3);
            if (!isValid1) {
                setDetailValidation({ quantity1: Constants.validateQtyMsg })
                return false;
            }
            /* 10873 - Validate targetUnit Price on copy paste and show error - Pankaj - Date: 28 April 2023 */
            const isValidTargetField = Common.validateTargetUnitPrice(params.targetUnitPrice, targetUnitPricePattern);
            if (!isValidTargetField) {
                setDetailValidation({ targetUnitPrice: 'Invalid entry. Only use dot as a decimal separator.' })
                return false;
            }
            return true;
        }
    }

    const resetForm = () => {
        setQuoteDetail(modal);
        setDetailValidation({})
    };

    const minValueTooltip = () => {
        return 'Depending on the minimum value threshold for quoting, the minimum quantity will be altered.';
    }

    const onSelectCPN = async (cpnVal) => {
        const rfqVal = await getRfqVal(cpnVal);
        setQuoteDetail({ ...quoteDetail, quantity1: rfqVal, quantity2: (quoteDetail.quantity2 !== defaultQtyVal ? rfqVal : defaultQtyVal), quantity3: (quoteDetail.quantity3 !== defaultQtyVal ? rfqVal : defaultQtyVal), customerPartNumber: cpnVal });
        setDetailValidation({});
    };

    const removeQuoteDetailValidation = (validationKey) => {
        if (Object.keys(detailValidation).length > 0 && detailValidation[validationKey]) {
            delete detailValidation[validationKey]
            return true;
        }
        return false;
    }

    const validateTargetPrice = (name, value) => {
        let t = value;
        t = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 6)) : t;
        onValueChange(name, t);
        if (detailValidation[name]) {
            const isValidTargetField = Common.validateTargetUnitPrice(t, targetUnitPricePattern);
            if (isValidTargetField)
                removeQuoteDetailValidation(name);
        }

    }

    const validateNumber = (evt, inputVal) => {
        removeQuoteDetailValidation('targetUnitPrice');
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode === 46) {
            if (!(inputVal && inputVal.indexOf(".") > -1)) {
                return true;
            }
        }
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    return (
        <Modal isDrag={true} isDisabled={isDisabled} show={QUOTE_POPUP_STATUS} onHide={() => { onHide() }}>
            <div className="avnet-modal modal-730">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close pt-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×
                    </button>
                    {/* {ReusableDiv.PopupTitle("Request a Quote")} */}
                    <div className="bs5 modal-header border-0" onMouseEnter={() => setIsDisabled(false)} onMouseLeave={() => setIsDisabled(true)}>
                        <h3 className="modal-title m-auto" id="exampleModalLabel">Request a Quote</h3>
                    </div>
                    {/* Modal body */}
                    {currentProduct !== undefined &&
                        <div className="modal-body px-md-5 pb-4">
                            <div className="clearfix" />
                            <div className="label-value mb-3">
                                <div className="label-value-item">
                                    <label><b>Quote No.</b></label>
                                    <span>Open</span>
                                </div>
                                <div className="label-value-item">
                                    <label><b>Part Number:</b></label>
                                    <span>{currentProduct.ERPMFRPartNumber}</span>
                                </div>
                                <div className="label-value-item">
                                    <label><b>Manufacturer:</b></label>
                                    <span>{currentProduct.ManufacturerName}</span>
                                </div>
                            </div>
                            <div className="bs5 row" onClick={() => !isDisabled && setIsDisabled(true)}>
                                <div className="col-md-6">
                                    <QuoteCustomerPartNumberOptions
                                        single_product={currentProduct}
                                        defaultValue={quoteDetail.customerPartNumber}
                                        isForEdit={isEdit}
                                        updationCompletedCallback={async (SELECTED_CUSTOMER_PART_NUMBER) => {
                                            onSelectCPN(SELECTED_CUSTOMER_PART_NUMBER)
                                        }}
                                    />
                                </div>
                                <div className="col-md-6 mt-auto">
                                    <div className="form-group">
                                        <label htmlFor="currency">Target Currency </label>
                                        <div className="selectbox">
                                            <CurrencyOptions defaultValue={quoteDetail.targetCurrency}
                                                onChange={(value) => { onValueChange('targetCurrency', value) }} />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12"><b>Minimum Required Quantity for Quoting</b>
                                    <Tooltip position={'right'}
                                        opener={() => (<i className="fa fa-info-circle ms-1 font-13" />)}
                                        content={() => (minValueTooltip())}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className='col-12 px-0'>
                                        <label htmlFor="Quantity" className="form-label">Quantity</label>
                                    </div>

                                    <div className='bs5 col px-0'>
                                        <div className='position-relative'>

                                            {__check('COMMON_API_CALL').status &&
                                                <div className='btn-sm w-100 inputloader'>
                                                    <i className="fa fa-spinner fa-spin" />
                                                </div>
                                            }

                                            <PlusMinusInputWithDebounceRFQ
                                                disable_validation_check={true}
                                                name="quantity1" type="text"
                                                className="form-control form-control-sm input-number bg-white"
                                                QtyMin={rfqQty}
                                                QtyMult={currentProduct.QtyMult}
                                                force_default_quantity={quoteDetail.quantity1}
                                                onChange={(err, value) => {
                                                    handleChange(1, {
                                                        target: {
                                                            'name': "quantity1",
                                                            err,
                                                            value
                                                        }
                                                    });
                                                }}
                                            />
                                        </div>
                                        {detailValidation.quantity1 && <p className="error"> {detailValidation.quantity1}</p>}
                                    </div>
                                    {quoteDetail.quantity2 === defaultQtyVal ?
                                        <a className={`add-more d-block mb-2 text-blue2 ${(__check('COMMON_API_CALL').status === true) ? 'pe-none text-muted' : ''} `}
                                            disabled={__check('COMMON_API_CALL').status === true}
                                            onClick={(value) => { onValueChange('quantity2', rfqQty) }}>+ Add another quantity</a> : null
                                    }

                                    {/* Qty 2 */}
                                    {(quoteDetail.quantity2 !== defaultQtyVal) ?
                                        <>
                                            <div className='col-12 px-0'>
                                                <label htmlFor="Quantity" className="form-label">Quantity</label>
                                            </div>
                                            <div className='bs5 col px-0'>
                                                <div className='rfq-quantity-close position-relative'>
                                                    {__check('COMMON_API_CALL').status &&
                                                        <div className='btn-sm w-100 inputloader'>
                                                            <i className="fa fa-spinner fa-spin" />
                                                        </div>
                                                    }
                                                    <PlusMinusInputWithDebounceRFQ
                                                        disable_validation_check={true}
                                                        name="quantity2" type="text"
                                                        className="form-control form-control-sm input-number bg-white"
                                                        QtyMin={rfqQty}
                                                        QtyMult={currentProduct.QtyMult}
                                                        force_default_quantity={quoteDetail.quantity2}
                                                        onChange={(err, value) => {
                                                            handleChange(2, {
                                                                target: {
                                                                    'name': "quantity2",
                                                                    err,
                                                                    value
                                                                }
                                                            });
                                                        }}
                                                    />

                                                    <div className='bs5 col-auto px-0'>
                                                        <button type="button" className="remove-email btn-link text-black-stone mb-0 py-1">
                                                            <span className="fa fa-times" onClick={() => removeFormFields(2)} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {detailValidation.quantity2 && <p className="error"> {detailValidation.quantity2}</p>}
                                            {quoteDetail.quantity3 === defaultQtyVal &&
                                                <a className={`add-more d-block mb-2 text-blue2 ${(__check('COMMON_API_CALL').status === true) ? 'pe-none text-muted' : ''} `}
                                                    disabled={__check('COMMON_API_CALL').status === true}
                                                    onClick={(value) => { onValueChange('quantity3', rfqQty) }}>+ Add another quantity</a>
                                            }
                                        </> : null}

                                    {/* Qty 3 */}
                                    {(quoteDetail.quantity3 !== defaultQtyVal) ?
                                        <>
                                            <div className='col-12 px-0'>
                                                <label htmlFor="Quantity" className="form-label">Quantity</label>
                                            </div>

                                            <div className='bs5 col px-0'>
                                                <div className='rfq-quantity-close position-relative'>
                                                    {__check('COMMON_API_CALL').status &&
                                                        <div className='btn-sm w-100 inputloader'>
                                                            <i className="fa fa-spinner fa-spin" />
                                                        </div>
                                                    }

                                                    <PlusMinusInputWithDebounceRFQ
                                                        disable_validation_check={true}
                                                        name="quantity3" type="text"
                                                        className="form-control form-control-sm input-number bg-white"
                                                        QtyMin={rfqQty}
                                                        QtyMult={currentProduct.QtyMult}
                                                        force_default_quantity={quoteDetail.quantity3}
                                                        onChange={(err, value) => {
                                                            handleChange(3, {
                                                                target: {
                                                                    'name': "quantity3",
                                                                    err,
                                                                    value
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    <div className='bs5 col-auto px-0'>
                                                        <button type="button" className="remove-email btn-link text-black-stone mb-0 py-1">
                                                            <span className="fa fa-times" onClick={() => removeFormFields(3)} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {detailValidation.quantity3 && <p className="error"> {detailValidation.quantity3}</p>}
                                        </> : null}
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="Unit" className="form-label d-block">Target Unit Price (Optional)</label>
                                        {/** 8693 - Change input type to text and added validation for allow number & decimal 13 March 2023 */}
                                        <input type="text" className="form-control form-control-sm"
                                            placeholder="Only use dot as decimal separator" id="targetUnitPrice" name="targetUnitPrice"
                                            value={quoteDetail.targetUnitPrice || ''}
                                            maxLength={14}
                                            onChange={({ target: { value } }) => validateTargetPrice('targetUnitPrice', value)}
                                            onKeyPress={(evt) => validateNumber(evt, evt.target.value) === false && evt.preventDefault()}
                                        />
                                        {detailValidation.targetUnitPrice && <p className="error"> {detailValidation.targetUnitPrice}</p>}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="Customer" className="form-label d-block mb-0">End Customer</label>
                                        <input type="text" className="form-control form-control-sm" id="endCustomer"
                                            placeholder="Customer" name="endCustomer" maxLength={35}
                                            value={quoteDetail.endCustomer}
                                            onChange={({ target: { value } }) => onValueChange('endCustomer', value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="Competition" className="form-label d-block mb-0">Competition</label>
                                        <input type="text" className="form-control form-control-sm" id="Competition"
                                            placeholder="Competition" name="competition" maxLength={72}
                                            value={quoteDetail.competition}
                                            onChange={({ target: { value } }) => onValueChange('competition', value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="mb-3">
                                        <label htmlFor="Comments" className="form-label d-block mb-0">Comments</label>
                                        <input type="text" className="form-control form-control-sm" id="Comments"
                                            placeholder="Comments" name="comments" maxLength={72}
                                            value={quoteDetail.comments}
                                            onChange={({ target: { value } }) => onValueChange('comments', value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* Modal footer */}
                    <div className="modal-footer d-block text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                data-bs-toggle="modal"
                                data-bs-target="#RequestModal"
                                onClick={() => { onHide() }}>
                                CANCEL
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145" data-bs-toggle="modal"
                                disabled={Object.keys(detailValidation).length > 0 || __check('COMMON_API_CALL').status === true}
                                data-bs-target="#RequestModal"
                                onClick={() => onSubmit()}>
                                {isEdit ? 'Save Changes' : 'Add to quote'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default QuotePopup;